import { StatusFilterType } from "./statusFilterType";
import { TrailerSortType } from "./trailerSortType";

export class TrailerRequestPayload {
  locations: string[];
  sortType: TrailerSortType;
  statusFilter: StatusFilterType;
  statusFilters: StatusFilterType[];
  ascending: boolean;
  fromDate: string;
  toDate: string;
  skip: number;
  take: number;
  query: string;
  requestType: string[];
  trailerType: string[];
  destination: string;
  destinations: string[];
  destinationSort: string[];
  serviceLevel: string[];
  trailerVolume: string[];
  trailerDirection: string[];
  earliestDueDate: string;
  latestDueDate: string;
  lastUpdatedAfter: string;
  unreadCommentsOnly: boolean;
  scrollPosition: number;
  locationUsersSearchTerm: string;
  locationSearchTerm: string;
  planNotMet: string[];
  createdAs: string[];
  shouldUpdateLocationMetrics?: boolean;
}
